import { render } from "./TraineeProgressModal.vue?vue&type=template&id=06e7a71b&scoped=true"
import script from "./TraineeProgressModal.vue?vue&type=script&lang=js"
export * from "./TraineeProgressModal.vue?vue&type=script&lang=js"

import "./TraineeProgressModal.vue?vue&type=style&index=0&id=06e7a71b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e7a71b"]])

export default __exports__